import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { getArticlesByClusterId } from '../../../api/articles/articlesApi';
import HorizontalNews from '../HorizontalNews/HorizontalNews';
import VerticalNews from '../VerticalNews/VerticalNews';
import './styles.mainnews.scss';
interface Props {
    mainNews: any;
    newsCategory?: string;
}

const MainNews = (props: Props) => {
    const [index, setIndex] = useState<number>(0);
    const [mainNewsLst, setMainNewsLst] = useState<any>(props.mainNews ? props.mainNews.articles.slice(1, 3) : []);
    const [lstNews, setLstNews] = useState<any>();

    useEffect(() => {
        if (props.mainNews) {
            getLstArticleByCluster();
        }
    }, []);

    const viewMoreNew = () => {
        setIndex(index + 1);
        // add mainNewsLst 3 items from props.mainNews to mainNewsLst and index + 1 
        setMainNewsLst(mainNewsLst.concat(lstNews.slice(index * 3 + 3, index * 3 + 7)));
        // setMainNewsLst(lstNews.slice(index * 3 + 1, index * 3 + 4));
    }

    const getLstArticleByCluster = async () => {
        let tmp: any[] = []
        const req = {
            size: 100,
            offset: 0,
            clusterId: props.mainNews.cluster?.id
        }
        await getArticlesByClusterId(req)
            .then((data) => {
                if (data?.data?.data?.items && data?.data?.data?.items.length > 0) {
                    tmp = data?.data?.data?.items;
                    setLstNews(tmp);
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }


    return (
        <div className='main-news-container'>
            <HorizontalNews
                newsContent={props.mainNews.articles[0]}
                newsCategory={props.newsCategory}
                avgStd={props.mainNews.cluster?.avgStd}
                isSlider={true}
            />
            <AnimatePresence>
                <div className='main-news-items'>
                    {props.mainNews
                        ? mainNewsLst.map((news: any, index: any) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -50 }}
                                transition={{ duration: 0.3 }}
                                style={{ height: '100%' }}
                            >
                                <VerticalNews
                                    newsContent={news}
                                    // newsCategory={props.newsCategory}
                                    type={''}
                                    avgStd={news?.score}
                                />
                            </motion.div>
                        ))
                        : null
                    }
                </div>
            </AnimatePresence >
            {lstNews?.length - (3 * (index + 1)) >= 1 &&
                <div className='view-more' onClick={viewMoreNew}>
                    Xem thêm
                    {/* <span className='number-view-more'>{props.mainNews.length - (3 * (index + 1))}</span> */}
                </div>
            }
        </div >
    )
}

export default MainNews
